// CSV çoklu seçim süzgecinin (`<sütun>[in]=a,b`) DataTable süzgeç çipi: ham kod ("open,in_review")
// yerine çevrilmiş etiketler ("Durum: Açık, İncelemede"). Tek çip döner; mui-datatables çipi
// silince süzgeci boşaltır (custom filterType + dizi render → 'chip').
//
// Kullanım: `customFilterListOptions: csvFilterChip(<çevrilmiş etiket>, optionLabel)`.
// İlk kullanıcı KVKK talepleri (2fb477a2); KVKK rızaları da buradan alır.
export function csvFilterChip(label, optionLabel) {
  return {
    render: (v) => (v && v[0]
      ? [`${label}: ${String(v[0]).split(',').filter(Boolean).map(optionLabel).join(', ')}`]
      : []),
  };
}

export default csvFilterChip;
